import type { SpecialistProfile } from '@/types/domain';
import styles from './ProfileFeed.module.css';

export function InfoCard({ profile }: { profile: SpecialistProfile }): JSX.Element {
  // F-170 B2.3 + B2.6: reviews summary chip and languages chip removed
  // from the public profile ahead of the F-180 reviews redesign and the
  // UA-only MVP cut.
  const stats: string[] = [];
  if (profile.service_radius_km) {
    stats.push(`виїзд ${profile.service_radius_km} км`);
  }

  return (
    <article className={styles.card}>
      {profile.bio ? <p className={styles.infoBio}>{profile.bio}</p> : null}
      {stats.length ? (
        <p className={styles.infoStats}>{stats.join(' · ')}</p>
      ) : null}
    </article>
  );
}
